import { defineStore } from 'pinia'
import { camelCase, snakeCase } from 'lodash'
import repositoryFactory from '@/factories/repository-factory'
import HistoryRepository, { HistoryParams } from '@/repositories/history-repository'
import History from '@/models/History'

const storeKey = 'history'

export const useHistoryStore = defineStore(storeKey, {
  state: () => ({
    history: {} as History,
    cache: {} as { [key: string]: History },
  }),

  actions: {
    async fetch(params: HistoryParams) {
      const repository = (await repositoryFactory.create()).get(storeKey) as HistoryRepository
      params.target = params.target.map(t => {
        let result = snakeCase(t)
        if (/.*humid_1|.*press_1/.test(result)) {
          result = result.replace(/humid_1|press_1/g, match => camelCase(match))
        }
        return result
      })

      const result = await repository.get(params)
      this.history = result

      return this.history
    },
  },
})
